var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "5px",
    height: "5px",
    viewBox: "0 0 5 5",
    enableBackground: "new 0 0 5 5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#AEAEA6",
    points: "1.604,4.003 0.094,3.133 1.8,2.217 2.795,4.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDA865",
    points: "2.793,2.72 2.795,4.07 4.344,3.174 4.342,1.823  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB7C45",
    points: "4.886,2.089 4.342,1.873 4.343,1.823 4.906,2.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB7C45",
    points: "2.774,0.979 4.325,1.873 4.343,1.823 2.791,0.931  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDDA9",
    points: "3.354,1.155 4.906,2.048 4.343,1.823 2.791,0.931  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB7C45",
    points: "0.696,2.089 1.24,1.873 1.242,1.826 0.677,2.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB7C45",
    points: "2.808,0.979 1.257,1.873 1.239,1.823 2.79,0.931  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDA865",
    points: "2.228,1.155 0.677,2.048 1.242,1.826 2.79,0.931  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB7C45",
    points: "2.793,2.72 1.242,1.826 1.243,3.177 2.795,4.07  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.2,
    fill: "#631900",
    points: "3.236,3.544 2.793,2.719 2.793,2.822 3.189,3.572  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDDA9",
    points: "3.236,3.544 2.793,2.719 4.342,1.822 4.785,2.647  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDC893",
    points: "1.242,1.826 2.793,2.72 4.342,1.823 2.791,0.93  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDDA9",
    points: "2.349,3.546 2.793,2.72 2.793,2.822 2.397,3.571  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDA865",
    points: "2.35,3.544 2.793,2.72 1.242,1.826 0.801,2.647  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDA865",
    points: "1.366,1.826 2.791,1.002 4.218,1.823 2.792,2.647  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB7C45",
    points: "2.791,1.002 4.218,1.823 2.792,2.647  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDC893",
    points: "2.437,2.443 2.795,2.647 3.148,2.441 2.793,2.237  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.2,
    fill: "#631900",
    points: "2.052,2.221 2.792,2.647 4.218,1.823 2.791,1.002  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/emptyBox.5c86997b54e8edbc9cf0941ee43fd8a6.svg";
export { ForwardRef as ReactComponent };